import api from './api';

export const reservaService = {

  // Crear reserva (cliente, solo mercadopago)
  crearReservaCliente: async (data) => {
    const response = await api.post('/client/reservas', data);
    return response.data;
  },

  // Crear preferencia de pago para MercadoPago (cliente)
  crearPreferenciaPago: async (data) => {
    // Ajusta la URL si tu backend usa otra ruta
    const response = await api.post('/client/reservas/preferencia-pago', data);
    return response.data;
  },
  // Obtener reservas del cliente autenticado
  getMisReservas: async () => {
    const response = await api.get('/client/reservas');
    return response.data;
  },

  // Obtener reservas del establecimiento autenticado
  getReservasEstablecimiento: async () => {
    const response = await api.get('/establishment/reservas');
    return response.data;
  },

  // Crear reserva desde establecimiento (efectivo o mercadopago)
  crearReservaEstablecimiento: async (data) => {
    const response = await api.post('/establishment/reservas', data);
    return response.data;
  },

  // Alias para compatibilidad con el dashboard (storeEstablecimiento)
  storeEstablecimiento: async (data) => {
    // Usa el mismo endpoint que crearReservaEstablecimiento
    const response = await api.post('/establishment/reservas', data);
    return response.data;
  },

  // Obtener reporte de ingresos mensuales del establecimiento
  getReporteIngresos: async () => {
    const response = await api.get('/establishment/reportes/ingresos');
    return response.data;
  },

  // Obtener reservas de una cancha por fecha (para bloqueo de horas)
  getReservasPorCanchaYFecha: async (canchaId, fecha) => {
    // Ajusta la URL según tu backend
    const response = await api.get(`/canchas/${canchaId}/reservas?fecha=${fecha}`);
    return response.data;
  },

  // Obtener ingresos de un establecimiento (ADMIN)
  getReporteIngresosEstablecimiento: async (estId) => {
    // Ajusta la ruta si tu backend usa otra
    const response = await api.get(`/admin/establecimientos/${estId}/ingresos`);
    return response.data;
  },
    // Obtener reporte global de ingresos (ADMIN)
  getReporteIngresosGlobal: async () => {
    // Ajusta la ruta si tu backend usa otra
    const response = await api.get('/admin/reportes/ingresos-global');
    return response.data;
  },
    // Editar reserva desde establecimiento
  updateEstablecimiento: async (id, data) => {
    const response = await api.put(`/establishment/reservas/${id}`, data);
    return response.data;
  },
  getReservasPorEstablecimiento: async (establecimientoId, fecha) => {
  const response = await api.get(`/establecimientos/${establecimientoId}/reservas`, {
    params: { fecha }
  });
  return response.data;
},
};
